import(/* webpackMode: "eager" */ "/vercel/path0/src/app/trips/page.tsx");
